/**
 * Routes and the capability slug only — nothing else.
 *
 * `router/workspaces.ts` imports this **eagerly** to build the sidebar, so anything imported
 * here lands in the application entry. The console's vocabulary lives in `constants.ts`, which
 * only the lazily-loaded pages import.
 */
export const ROUTES = {
  overview: '/app/admin',
  affiliates: '/app/admin/affiliates',
  affiliateNew: '/app/admin/affiliates/new',
  affiliate: (id: string) => `/app/admin/affiliates/${id}`,
  landlords: '/app/admin/landlords',
  landlord: (id: number | string) => `/app/admin/landlords/${id}`,
  properties: '/app/admin/properties',
  property: (id: number | string) => `/app/admin/properties/${id}`,
  /** The property edit form (2026-10-27, later): the onboarding flow, as the console. */
  propertyEdit: (id: number | string) => `/app/admin/properties/${id}/edit`,
  /** The tenant register -- the landlord's Tenants page over every tenancy (tenancy module). */
  tenants: '/app/admin/tenants',
  payments: '/app/admin/payments',
  payment: (id: string) => `/app/admin/payments/${id}`,
  /** Students' space requests: the queue of what the marketplace could not answer. */
  spaceRequests: '/app/admin/space-requests',
  spaceRequest: (id: string) => `/app/admin/space-requests/${id}`,
  /** Students looking for a roommate (2026-10-22), under the space requests in the sidebar. */
  roommateRequests: '/app/admin/space-requests/roommates',
  roommateRequest: (id: string) => `/app/admin/space-requests/roommates/${id}`,
  audit: '/app/admin/audit',
  integrity: '/app/admin/integrity',
  anomalies: '/app/admin/anomalies',
  system: '/app/admin/system',
  settings: '/app/admin/settings',
  /** APMP on WhatsApp (2026-10-12): the owner's setup and the conversations. */
  whatsapp: '/app/admin/whatsapp',
  /** APMP's support officers (2026-10-12): the register and one officer. */
  supportOfficers: '/app/admin/support-officers',
  supportOfficer: (id: string) => `/app/admin/support-officers/${id}`,
  /** Affiliate institutions (2026-10-22): the register, a new one, one institution. */
  institutions: '/app/admin/institutions',
  institutionNew: '/app/admin/institutions/new',
  institution: (id: string) => `/app/admin/institutions/${id}`,
  profile: '/app/admin/profile',
} as const

/** Administration is one boundary; every admin route carries this one slug. */
export const CAPABILITIES = { adminAccess: 'admin.access' } as const
